<template>
  <section>
    <b-button
      v-if="isModal"
      size="is-small"
      class="login-trigger-button"
      style="border-radius: 6px"
      outlined
      @click="handleShowLogin()"
      >登录</b-button
    >
    <b-modal
      v-if="isModal"
      v-model="isComponentModalActive"
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
      :class="{ 'wechat-binding-modal': loginType === 'wechat' && wechatPhoneRequired }"
    >
      <div class="login-box" :class="{ 'wechat-login-box': loginType === 'wechat', 'wechat-binding-box': loginType === 'wechat' && wechatPhoneRequired }">
        <div class="login-box-l"></div>
        <div class="login-box-r">
          <div v-if="loginType !== 'wechat'" class="login-tabs">
            <div
              class="tab-item"
              :class="{ active: loginType === 'account' }"
              @click="switchLoginType('account')"
            >
              账号密码登录
            </div>
            <div
              class="tab-item"
              :class="{ active: loginType === 'phone' }"
              @click="switchLoginType('phone')"
            >
              验证码登录
            </div>
          </div>
          <div v-if="loginType === 'wechat'" class="wechat-login-panel">
            <div class="wechat-back-btn" @click="switchLoginType('account')">
              <span class="wechat-back-arrow" aria-hidden="true" /> 返回
            </div>
            <div v-if="wechatTicket.authorizeUrl && !wechatPhoneRequired" class="wechat-qr-frame">
              <iframe
                class="wechat-login-iframe"
                :src="wechatTicket.authorizeUrl"
                title="微信扫码登录"
                frameborder="0"
                scrolling="no"
              />
            </div>
            <p v-if="wechatPhoneRequired || !wechatTicket.authorizeUrl" class="wechat-login-message">{{ wechatMessage }}</p>
            <div v-if="wechatPhoneRequired" class="wechat-phone-form">
              <div class="wechat-contact-tabs"><b-button size="is-small" :type="wechatContactType === 'phone' ? 'is-info' : 'is-light'" @click="wechatContactType = 'phone'">手机号</b-button><b-button size="is-small" :type="wechatContactType === 'email' ? 'is-info' : 'is-light'" @click="wechatContactType = 'email'">邮箱</b-button></div>
              <b-input v-if="wechatContactType === 'phone'" v-model="wechatPhone" type="tel" maxlength="11" placeholder="请输入手机号" />
              <b-input v-else v-model="wechatEmail" type="email" maxlength="128" placeholder="请输入邮箱" />
              <div class="wechat-code-row">
                <b-input v-model="wechatContactCode" maxlength="6" :placeholder="wechatContactType === 'phone' ? '请输入短信验证码' : '请输入邮箱验证码'" />
                <b-button class="wechat-send-code" type="is-light" size="is-small" :disabled="wechatContactCountdown > 0" @click="sendWechatContactCode">{{ wechatContactCountdown > 0 ? `${wechatContactCountdown}秒后重发` : '获取验证码' }}</b-button>
              </div>
              <div class="wechat-phone-actions"><b-button type="is-light" size="is-small" @click="declineWechatBinding">拒绝</b-button><b-button type="is-primary" size="is-small" @click="bindWechatContact">允许</b-button></div>
            </div>
            <b-button v-if="!wechatPhoneRequired && !wechatTicket.authorizeUrl" type="is-light" size="is-small" @click="startWechatLogin">刷新二维码</b-button>
          </div>
          <form
            v-if="loginType !== 'wechat'"
            method="POST"
            @submit.prevent="handleLogin"
          >
            <!-- 账号密码登录 -->
            <div v-if="loginType === 'account'">
              <b-field
                style="height: 90px"
                label="用户名/手机号/邮箱"
                :message="usernameMessage"
              >
                <b-input
                  v-model="loginForm.username"
                  type="username"
                  required
                  placeholder="请输入用户名/手机号/邮箱"
                  @blur="validateUsername"
                />
              </b-field>
              <b-field style="height: 90px" label="密码" :message="pwdMessage">
                <b-input
                  v-model="loginForm.password"
                  type="password"
                  password-reveal
                  required
                  placeholder="请输入密码"
                  @blur="validatePwd"
                />
              </b-field>
              <div>
                <b-field
                  style="height: 90px"
                  label="图形验证码"
                  :message="codeMessage"
                >
                  <div class="input-field">
                    <b-input
                      :value="loginForm.code"
                      type="text"
                      required
                      maxlength="4"
                      :has-counter="false"
                      placeholder="请输入图形验证码"
                      @input="handleAccountCaptchaInput"
                      @blur="validateCode"
                    />
                    <div
                      class="login-code"
                      style="
                        cursor: pointer;
                        margin-left: 5px;
                        height: 40px;
                        float: right;
                        background-color: #f0f1f5;
                      "
                    >
                      <img
                        style="
                          width: 100%;
                          height: 40px;
                          border: 1px solid rgba(0, 0, 0, 0.1);
                          border-radius: 2px;
                        "
                        :src="codeUrl"
                        alt="yzm"
                        @click="getCode"
                      />
                    </div>
                  </div>
                </b-field>
              </div>
            </div>
            <!-- 验证码登录 -->
            <div v-else>
              <b-field
                style="height: 90px"
                label="手机号/邮箱"
                :message="phoneMessage"
              >
                <b-input
                  v-model="phoneForm.account"
                  type="text"
                  required
                  placeholder="请输入手机号或邮箱"
                  @input="handlePhoneInput"
                  @blur="validatePhone"
                />
              </b-field>
              <b-field
                style="height: 90px"
                label="图形验证码"
                :message="phoneCodeMessage"
              >
                <div class="input-field">
                  <b-input
                    :value="phoneForm.code"
                    type="text"
                    required
                    maxlength="4"
                    :has-counter="false"
                    placeholder="请输入图形验证码"
                    @input="handlePhoneCaptchaInput"
                    @blur="validatePhoneCode"
                  />
                  <div
                    class="login-code"
                    style="
                      cursor: pointer;
                      margin-left: 5px;
                      height: 40px;
                      float: right;
                      background-color: #f0f1f5;
                    "
                  >
                    <img
                      style="
                        width: 100%;
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        border-radius: 2px;
                      "
                      :src="codeUrl"
                      alt="yzm"
                      @click="getCode"
                    />
                  </div>
                </div>
              </b-field>
              <b-field
                v-if="accountType"
                style="height: 90px"
                :label="verifyCodeLabel"
                :message="smsCodeMessage"
              >
                <div class="input-field">
                  <b-input
                    v-model="phoneForm.verifyCode"
                    type="text"
                    required
                    :placeholder="verifyCodePlaceholder"
                    @blur="validateSmsCode"
                  />
                  <span
                    class="send-code-btn"
                    :class="{ disabled: countdown > 0 }"
                    @click="sendVerifyCode"
                  >
                    {{ sendCodeButtonText }}
                  </span>
                </div>
              </b-field>
            </div>
            <div class="login-footer-btn">
              <b-button
                class="item-btn"
                label="取消"
                type="is-light"
                @click="isComponentModalActive = false"
              />
              <b-button
                class="item-btn"
                label="登录"
                type="is-primary"
                @click="handleLogin"
              />
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <a
                class="login-zc"
                :href="signupUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
                >点击注册>></a
              >
              <a
                v-if="loginType === 'account'"
                class="login-zc"
                :href="forgetUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
                >忘记密码?</a
              >
            </div>
            <div class="wechat-entry">
              <a
                class="wechat-icon-link"
                title="微信扫码登录"
                @click.prevent="switchLoginType('wechat')"
              >
                <img class="wechat-icon" :src="wechatIcon" alt="微信扫码登录" />
                <span>微信登录</span>
              </a>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
    <div class="login-box" :class="{ 'wechat-login-box': loginType === 'wechat', 'wechat-binding-box': loginType === 'wechat' && wechatPhoneRequired }" v-else>
      <div class="login-box-l"></div>
      <div class="login-box-r">
        <div v-if="loginType !== 'wechat'" class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: loginType === 'account' }"
            @click="switchLoginType('account')"
          >
            账号密码登录
          </div>
          <div
            class="tab-item"
            :class="{ active: loginType === 'phone' }"
            @click="switchLoginType('phone')"
          >
            手机号/邮箱登录
          </div>
        </div>
        <div v-if="loginType === 'wechat'" class="wechat-login-panel">
          <button type="button" class="wechat-back-btn" @click="switchLoginType('account')">
            <span class="wechat-back-arrow" aria-hidden="true" /> 返回
          </button>
          <div v-if="wechatTicket.authorizeUrl && !wechatPhoneRequired" class="wechat-qr-frame">
            <iframe
              class="wechat-login-iframe"
              :src="wechatTicket.authorizeUrl"
              title="微信扫码登录"
              frameborder="0"
              scrolling="no"
            />
          </div>
          <p v-if="wechatPhoneRequired || !wechatTicket.authorizeUrl" class="wechat-login-message">{{ wechatMessage }}</p>
          <div v-if="wechatPhoneRequired" class="wechat-phone-form">
            <div class="wechat-contact-tabs"><b-button size="is-small" :type="wechatContactType === 'phone' ? 'is-info' : 'is-light'" @click="wechatContactType = 'phone'">手机号</b-button><b-button size="is-small" :type="wechatContactType === 'email' ? 'is-info' : 'is-light'" @click="wechatContactType = 'email'">邮箱</b-button></div>
            <b-input v-if="wechatContactType === 'phone'" v-model="wechatPhone" type="tel" maxlength="11" placeholder="请输入手机号" />
            <b-input v-else v-model="wechatEmail" type="email" maxlength="128" placeholder="请输入邮箱" />
            <div class="wechat-code-row">
              <b-input v-model="wechatContactCode" maxlength="6" :placeholder="wechatContactType === 'phone' ? '请输入短信验证码' : '请输入邮箱验证码'" />
              <b-button class="wechat-send-code" type="is-light" size="is-small" :disabled="wechatContactCountdown > 0" @click="sendWechatContactCode">{{ wechatContactCountdown > 0 ? `${wechatContactCountdown}秒后重发` : '获取验证码' }}</b-button>
            </div>
            <div class="wechat-phone-actions"><b-button type="is-light" size="is-small" @click="declineWechatBinding">拒绝</b-button><b-button type="is-primary" size="is-small" @click="bindWechatContact">允许</b-button></div>
          </div>
          <b-button v-if="!wechatPhoneRequired && !wechatTicket.authorizeUrl" type="is-light" size="is-small" @click="startWechatLogin">刷新二维码</b-button>
        </div>
        <form v-if="loginType !== 'wechat'" method="POST" @submit.prevent="handleLogin">
          <!-- 账号密码登录 -->
          <div v-if="loginType === 'account'">
            <b-field
              style="height: 90px"
              label="用户名/手机号/邮箱"
              :message="usernameMessage"
            >
              <b-input
                v-model="loginForm.username"
                type="username"
                required
                placeholder="请输入用户名/手机号/邮箱"
                @blur="validateUsername"
              />
            </b-field>
            <b-field style="height: 90px" label="密码" :message="pwdMessage">
              <b-input
                v-model="loginForm.password"
                type="password"
                password-reveal
                required
                placeholder="请输入密码"
                @blur="validatePwd"
              />
            </b-field>
            <div>
              <b-field
                style="height: 90px"
                label="图形验证码"
                :message="codeMessage"
              >
                <b-input
                  :value="loginForm.code"
                  type="text"
                  required
                  maxlength="4"
                  :has-counter="false"
                  placeholder="请输入图形验证码"
                  @input="handleAccountCaptchaInput"
                  @blur="validateCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </b-field>
            </div>
          </div>
          <!-- 验证码登录 -->
          <div v-else>
            <b-field
              style="height: 90px"
              label="手机号/邮箱"
              :message="phoneMessage"
            >
              <b-input
                v-model="phoneForm.account"
                type="text"
                required
                placeholder="请输入手机号或邮箱"
                @input="handlePhoneInput"
                @blur="validatePhone"
              />
            </b-field>
            <b-field
              v-if="accountType"
              style="height: 90px"
              label="图形验证码"
              :message="phoneCodeMessage"
            >
              <div class="input-field">
                <b-input
                  :value="phoneForm.code"
                  type="text"
                  required
                  maxlength="4"
                  :has-counter="false"
                  placeholder="请输入图形验证码"
                  @input="handlePhoneCaptchaInput"
                  @blur="validatePhoneCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </div>
            </b-field>
            <b-field
              v-if="accountType"
              style="height: 90px"
              :label="verifyCodeLabel"
              :message="smsCodeMessage"
            >
              <div class="input-field">
                <b-input
                  v-model="phoneForm.verifyCode"
                  type="text"
                  required
                  :placeholder="verifyCodePlaceholder"
                  @blur="validateSmsCode"
                />
                <span
                  class="send-code-btn"
                  :class="{ disabled: countdown > 0 }"
                  @click="sendVerifyCode"
                >
                  {{ sendCodeButtonText }}
                </span>
              </div>
            </b-field>
          </div>
          <div class="login-footer-btn">
            <b-button
              class="item-btn"
              label="取消"
              type="is-light"
              @click="isComponentModalActive = false"
            />
            <b-button
              class="item-btn"
              label="登录"
              type="is-primary"
              @click="handleLogin"
            />
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <a
              class="login-zc"
              :href="signupUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
              >点击注册>></a
            >
            <a
              v-if="loginType === 'account'"
              class="login-zc"
              :href="forgetUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
              >忘记密码?</a
            >
          </div>
          <div class="wechat-entry">
            <a
              class="wechat-icon-link"
              title="微信扫码登录"
              @click.prevent="switchLoginType('wechat')"
            >
              <img class="wechat-icon" :src="wechatIcon" alt="微信扫码登录" />
              <span>微信登录</span>
            </a>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { getCodeImg, sendSmsCode, sendEmailCode } from "@/api/login";
import { createWechatTicket, getWechatTicketStatus, exchangeWechatTicket, cancelWechatTicket, sendWechatPhoneChallenge, bindWechatPhone, sendWechatEmailChallenge, bindWechatEmail } from "@/api/user";
import wechatIcon from "@/assets/icon-wechat.png";
export default {
  props: {
    isModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      wechatIcon,
      signupUrl: process.env.VUE_APP_BBS_URL + "/user/signup",
      forgetUrl: process.env.VUE_APP_BBS_URL + "/user/forget",
      indefinteToast: "",
      codeUrl: "",
      isLoading: false,
      isLoadingCaptcha: false,
      captchaRequestId: 0,
      isSendingVerifyCode: false,
      formValid: false,
      usernameMessage: "",
      usernameValid: false,
      pwdMessage: "",
      pwdValid: false,
      codeMessage: "",
      codeValid: false,
      phoneMessage: "",
      phoneValid: false,
      smsCodeMessage: "",
      smsCodeValid: false,
      phoneCodeMessage: "",
      phoneCodeValid: false,
      isComponentModalActive: false,
      loginType: "account",
      accountType: "",
      countdown: 0,
      countdownTimer: null,
      loginForm: {
        username: undefined,
        password: undefined,
        rememberMe: false,
        code: undefined,
        uuid: "",
      },
      phoneForm: {
        account: undefined,
        verifyCode: undefined,
        code: undefined,
        uuid: "",
      },
      wechatTicket: { ticketId: "", pollToken: "", authorizeUrl: "" },
      wechatMessage: "使用微信扫描二维码登录",
      wechatRequestId: 0,
      wechatLastCreateAt: 0,
      wechatPollTimer: null,
      wechatPolling: false,
      wechatPhoneRequired: false,
      wechatPhone: "",
      wechatSmsCode: "",
      wechatPhoneChallenge: "",
      wechatEmail: "",
      wechatEmailChallenge: "",
      wechatContactCode: "",
      wechatContactType: "phone",
      wechatContactCountdown: 0,
      wechatContactCountdownTimer: null,
    };
  },
  watch: {
    isComponentModalActive(active) {
      if (!active && this.loginType === "wechat") this.cancelWechatLogin();
    },
  },
  computed: {
    verifyCodeLabel() {
      if (this.accountType === "email") {
        return "邮箱验证码";
      }
      if (this.accountType === "phone") {
        return "短信验证码";
      }
      return "验证码";
    },
    verifyCodePlaceholder() {
      return `请输入${this.verifyCodeLabel}`;
    },
    sendCodeButtonText() {
      return this.countdown > 0
        ? `${this.countdown}秒后重发`
        : `发送${this.verifyCodeLabel}`;
    },
    verifyCodeReceiveTarget() {
      if (this.accountType === "email") {
        return "邮箱";
      }
      if (this.accountType === "phone") {
        return "手机";
      }
      return "手机或邮箱";
    },
    loginActionName() {
      return this.accountType === "email"
        ? "emailLoginAction"
        : "phoneLoginAction";
    },
  },
  created() {
    this.loginEventHandler = () => {
      this.isComponentModalActive = true;
      this.getCode();
    };
    document.addEventListener(
      "csCustomLoginEvent",
      this.loginEventHandler,
      {
        once: false,
      }
    );
  },
  beforeDestroy() {
    this.clearCountdown();
    this.cancelWechatLogin();
    if (this.loginEventHandler) {
      document.removeEventListener("csCustomLoginEvent", this.loginEventHandler);
    }
  },
  methods: {
    handleShowLogin() {
      this.getCode();
      sessionStorage.setItem("attemptedURL", this.$route.fullPath);
      this.isComponentModalActive = true;
    },
    switchLoginType(type) {
      if (this.loginType === type) {
        return;
      }
      if (this.loginType === "wechat" && type !== "wechat") this.stopWechatLogin();
      this.loginType = type;
      if (type === "wechat") {
        this.startWechatLogin();
        return;
      }
      this.stopWechatLogin();
      if (type === "phone") {
        this.handlePhoneInput();
        this.getCode();
        return;
      }
      this.resetPhoneVerifyState();
    },
    stopWechatLogin() {
      this.wechatRequestId += 1;
      if (this.wechatPollTimer) { clearTimeout(this.wechatPollTimer); this.wechatPollTimer = null; }
      this.wechatPolling = false;
    },
    clearWechatContactCountdown() {
      if (this.wechatContactCountdownTimer) {
        clearInterval(this.wechatContactCountdownTimer);
        this.wechatContactCountdownTimer = null;
      }
      this.wechatContactCountdown = 0;
    },
    startWechatContactCountdown() {
      this.clearWechatContactCountdown();
      this.wechatContactCountdown = 60;
      this.wechatContactCountdownTimer = setInterval(() => {
        if (this.wechatContactCountdown <= 1) {
          this.clearWechatContactCountdown();
          return;
        }
        this.wechatContactCountdown -= 1;
      }, 1000);
    },
    cancelWechatLogin() {
      this.wechatRequestId += 1;
      const ticket = this.wechatTicket;
      this.stopWechatLogin();
      this.clearWechatContactCountdown();
      if (ticket && ticket.ticketId && ticket.pollToken) {
        cancelWechatTicket(ticket.ticketId, ticket.pollToken).catch(() => {});
      }
    },
    startWechatLogin() {
      // 已有有效二维码时直接复用，避免快速切换触发后端限流(429)
      if (this.wechatTicket && this.wechatTicket.ticketId && this.wechatTicket.authorizeUrl) {
        this.wechatMessage = "请使用微信扫描二维码";
        if (!this.wechatPolling) this.pollWechatTicket();
        return;
      }
      // 后端对同一 IP 创建二维码限流 5 秒，前端节流避免 429
      const now = Date.now();
      if (this.wechatLastCreateAt && now - this.wechatLastCreateAt < 5000) {
        this.wechatMessage = "正在生成二维码，请稍候...";
        return;
      }
      this.cancelWechatLogin();
      const requestId = ++this.wechatRequestId;
      this.wechatLastCreateAt = now;
      this.wechatTicket = { ticketId: "", pollToken: "", authorizeUrl: "" };
      this.wechatPhoneRequired = false;
      this.wechatPhone = "";
      this.wechatSmsCode = "";
      this.wechatPhoneChallenge = "";
      this.wechatEmail = "";
      this.wechatEmailChallenge = "";
      this.wechatContactCode = "";
      this.wechatContactType = "phone";
      this.clearWechatContactCountdown();
      this.wechatMessage = "正在生成二维码...";
      createWechatTicket({ clientType: "pc_web", redirectPath: this.$route.fullPath || "/" }).then((res) => {
        // 期间又切换过 tab / 重新请求过（或已取消），丢弃过期响应
        if (requestId !== this.wechatRequestId) return;
        const data = res && res.data ? res.data : res;
        if (!data || !data.ticketId) throw new Error("微信登录未开启");
        this.wechatTicket = data;
        this.wechatMessage = "请使用微信扫描二维码";
        this.pollWechatTicket();
      }).catch(() => {
        if (requestId !== this.wechatRequestId) return;
        this.wechatMessage = "微信登录暂不可用，请使用其他方式";
      });
    },
    pollWechatTicket() {
      if (this.wechatPolling || !this.wechatTicket.ticketId) return;
      this.wechatPolling = true;
      const requestId = this.wechatRequestId;
      getWechatTicketStatus(this.wechatTicket.ticketId, this.wechatTicket.pollToken).then((res) => {
        if (requestId !== this.wechatRequestId) return null;
        const data = res && res.data ? res.data : res;
        const status = data && data.status;
        if (status === "SUCCESS") {
          this.wechatMessage = "登录成功，正在进入...";
          return exchangeWechatTicket(this.wechatTicket.ticketId, this.wechatTicket.pollToken).then((result) => this.$store.dispatch("wechatLoginAction", result));
        }
        if (status === "PHONE_REQUIRED") {
          this.wechatPhoneRequired = true;
          this.wechatMessage = "该微信尚未绑定手机号或邮箱，请完成验证";
        }
        if (status === "EXPIRED" || status === "CANCELLED" || status === "FAILED") {
          this.wechatPolling = false;
          this.wechatTicket.authorizeUrl = "";
          if (this.wechatPollTimer) { clearTimeout(this.wechatPollTimer); this.wechatPollTimer = null; }
          const errorCode = data && data.errorCode;
          this.wechatMessage = status === "FAILED" && errorCode === "PHONE_BIND_CONFLICT"
            ? "该手机号已绑定其他微信账号，请更换手机号"
            : "二维码已失效，请刷新重试";
          return null;
        }
        this.wechatPollTimer = setTimeout(() => { this.wechatPolling = false; this.pollWechatTicket(); }, 2000);
        return null;
      }).then((result) => {
        if (requestId !== this.wechatRequestId) return;
        if (result && this.loginType === "wechat") { this.stopWechatLogin(); this.isComponentModalActive = false; this.$emit("loginSuccess"); }
      }).catch(() => {
        if (requestId !== this.wechatRequestId) return;
        this.wechatPolling = false;
        this.wechatTicket.authorizeUrl = "";
        this.wechatMessage = "登录失败，请刷新二维码";
      });
    },
    sendWechatPhoneCode() {
      if (!/^1[3-9]\d{9}$/.test(this.wechatPhone)) {
        this.wechatMessage = "请输入正确的手机号";
        return;
      }
      sendWechatPhoneChallenge(this.wechatTicket.ticketId, this.wechatPhone, this.wechatTicket.pollToken).then((res) => {
        const data = res && res.data ? res.data : res;
        this.wechatPhoneChallenge = data && data.challenge ? data.challenge : "";
        if (this.wechatPhoneChallenge) this.startWechatContactCountdown();
        this.wechatMessage = this.wechatPhoneChallenge
          ? "验证码已发送，请输入短信验证码"
          : this.wechatErrorMessage(res, "验证码发送失败，请重试");
      }).catch((err) => { this.wechatMessage = this.wechatErrorMessage(err, "验证码发送失败，请重试"); });
    },
    sendWechatContactCode() {
      if (this.wechatContactCountdown > 0) return;
      if (this.wechatContactType === "phone") {
        this.wechatSmsCode = this.wechatContactCode;
        return this.sendWechatPhoneCode();
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.wechatEmail)) {
        this.wechatMessage = "请输入正确的邮箱";
        return;
      }
      sendWechatEmailChallenge(this.wechatTicket.ticketId, this.wechatEmail, this.wechatTicket.pollToken).then((res) => {
        const data = res && res.data ? res.data : res;
        this.wechatEmailChallenge = data && data.challenge ? data.challenge : "";
        if (this.wechatEmailChallenge) this.startWechatContactCountdown();
        this.wechatMessage = this.wechatEmailChallenge
          ? "验证码已发送，请输入邮箱验证码"
          : this.wechatErrorMessage(res, "验证码发送失败，请重试");
      }).catch((err) => { this.wechatMessage = this.wechatErrorMessage(err, "验证码发送失败，请重试"); });
    },
    bindWechatSms() {
      if (!this.wechatPhoneChallenge || !this.wechatSmsCode) {
        this.wechatMessage = "请输入短信验证码";
        return;
      }
      bindWechatPhone(this.wechatTicket.ticketId, {
        phone: this.wechatPhone,
        smsCode: this.wechatSmsCode,
        challenge: this.wechatPhoneChallenge,
      }, this.wechatTicket.pollToken).then(() => {
        this.wechatPhoneRequired = false;
        this.wechatMessage = "绑定成功，正在进入...";
        this.pollWechatTicket();
      }).catch((err) => { this.wechatMessage = this.wechatErrorMessage(err, "手机号绑定失败，请重试"); });
    },
    bindWechatContact() {
      if (this.wechatContactType === "phone") {
        this.wechatSmsCode = this.wechatContactCode;
        return this.bindWechatSms();
      }
      if (!this.wechatEmailChallenge || !this.wechatContactCode) {
        this.wechatMessage = "请输入邮箱验证码";
        return;
      }
      bindWechatEmail(this.wechatTicket.ticketId, { email: this.wechatEmail, emailCode: this.wechatContactCode, challenge: this.wechatEmailChallenge }, this.wechatTicket.pollToken).then(() => {
        this.wechatPhoneRequired = false;
        this.wechatMessage = "绑定成功，正在进入...";
        this.pollWechatTicket();
      }).catch((err) => { this.wechatMessage = this.wechatErrorMessage(err, "邮箱绑定失败，请重试"); });
    },
    declineWechatBinding() {
      this.cancelWechatLogin();
      this.isComponentModalActive = false;
    },
    wechatErrorMessage(response, fallback) {
      const candidates = [
        response && response.msg,
        response && response.data && response.data.msg,
        response && response.response && response.response.data && response.response.data.msg,
      ];
      const message = candidates.find((value) => typeof value === "string" && value.trim());
      return message || fallback;
    },
    getCode() {
      if (this.isLoadingCaptcha) {
        return;
      }
      const requestId = Date.now();
      this.captchaRequestId = requestId;
      this.isLoadingCaptcha = true;
      this.loginForm.code = "";
      this.phoneForm.code = "";
      getCodeImg()
        .then((res) => {
          // 只接受最后一次验证码响应，避免响应乱序覆盖当前验证码
          if (this.captchaRequestId !== requestId || res === undefined) {
            return;
          }
          this.codeUrl = res.data;
          this.loginForm.uuid = res.id;
          this.phoneForm.uuid = res.id;
        })
        .finally(() => {
          this.isLoadingCaptcha = false;
        });
    },
    validateUsername() {
      if (!this.loginForm.username) {
        this.usernameValid = false;
        this.usernameMessage = "账号不能为空";
      } else {
        this.usernameValid = true;
        this.usernameMessage = "";
      }
    },
    validatePwd() {
      if (!this.loginForm.password) {
        this.pwdValid = false;
        this.pwdMessage = "密码不能为空";
      } else {
        this.pwdValid = true;
        this.pwdMessage = "";
      }
    },
    handleAccountCaptchaInput(value) {
      this.loginForm.code = String(value || "").replace(/\D/g, "").slice(0, 4);
    },
    handlePhoneCaptchaInput(value) {
      this.phoneForm.code = String(value || "").replace(/\D/g, "").slice(0, 4);
    },
    validateCode() {
      if (!this.loginForm.code) {
        this.codeValid = false;
        this.codeMessage = "图形验证码不能为空";
      } else {
        this.codeValid = true;
        this.codeMessage = "";
      }
    },
    detectAccountType(account) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      const currentAccount = (account || "").trim();
      if (phoneRegex.test(currentAccount)) {
        return "phone";
      }
      if (emailRegex.test(currentAccount)) {
        return "email";
      }
      return "";
    },
    getAccountFieldName() {
      return this.accountType === "email" ? "email" : "mobile";
    },
    getVerifyCodeFieldName() {
      return this.accountType === "email" ? "emailCode" : "smsCode";
    },
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },
    resetPhoneVerifyState() {
      this.clearCountdown();
      this.phoneForm.code = undefined;
      this.phoneForm.verifyCode = undefined;
      this.phoneCodeValid = false;
      this.phoneCodeMessage = "";
      this.smsCodeValid = false;
      this.smsCodeMessage = "";
    },
    handlePhoneInput() {
      this.accountType = this.detectAccountType(this.phoneForm.account);
      this.resetPhoneVerifyState();
    },
    getVerifyCodeEmptyMessage() {
      return `${this.verifyCodeLabel}不能为空`;
    },
    getPhoneLoginSubmitMessage() {
      if (!this.phoneForm.account) {
        return "请输入手机号或邮箱";
      }
      if (!this.accountType) {
        return "请输入正确的手机号或邮箱";
      }
      if (!this.phoneForm.code) {
        return "请输入图形验证码";
      }
      if (!this.phoneForm.verifyCode) {
        return `请输入${this.verifyCodeLabel}`;
      }
      return `请检查输入的手机号/邮箱、图形验证码和${this.verifyCodeLabel}`;
    },
    validatePhone() {
      const account = (this.phoneForm.account || "").trim();
      this.phoneForm.account = account;
      this.accountType = this.detectAccountType(account);
      if (!account) {
        this.phoneValid = false;
        this.phoneMessage = "手机号或邮箱不能为空";
      } else if (!this.accountType) {
        this.phoneValid = false;
        this.phoneMessage = "请输入正确的手机号或邮箱";
      } else {
        this.phoneValid = true;
        this.phoneMessage = "";
      }
    },
    validateSmsCode() {
      if (!this.phoneForm.verifyCode) {
        this.smsCodeValid = false;
        this.smsCodeMessage = this.getVerifyCodeEmptyMessage();
      } else {
        this.smsCodeValid = true;
        this.smsCodeMessage = "";
      }
    },
    validatePhoneCode() {
      if (!this.phoneForm.code) {
        this.phoneCodeValid = false;
        this.phoneCodeMessage = "图形验证码不能为空";
      } else {
        this.phoneCodeValid = true;
        this.phoneCodeMessage = "";
      }
    },
    buildSendCodeData() {
      return {
        [this.getAccountFieldName()]: this.phoneForm.account,
        uuid: this.phoneForm.uuid,
        code: this.phoneForm.code,
      };
    },
    buildLoginData() {
      return {
        [this.getAccountFieldName()]: this.phoneForm.account,
        [this.getVerifyCodeFieldName()]: this.phoneForm.verifyCode,
      };
    },
    sendVerifyCode() {
      if (this.countdown > 0 || this.isSendingVerifyCode) {
        return;
      }
      if (!this.phoneValid) {
        this.validatePhone();
        if (!this.phoneValid) {
          return;
        }
      }
      if (!this.phoneCodeValid) {
        this.validatePhoneCode();
        if (!this.phoneCodeValid) {
          return;
        }
      }
      const data = this.buildSendCodeData();
      const request = this.accountType === "email" ? sendEmailCode : sendSmsCode;
      this.isSendingVerifyCode = true;
      request(data)
        .then((rr) => {
          if (rr.code === 500) {
            this.phoneForm.code = "";
            this.indefinteToast = this.$buefy.toast.open({
              duration: 2000,
              message: rr.msg,
              type: "is-danger",
            });
            this.getCode();
            return;
          }
          this.clearCountdown();
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              this.clearCountdown();
            }
          }, 1000);
          this.indefinteToast = this.$buefy.toast.open({
            duration: 2000,
            message: `${this.verifyCodeLabel}已发送，请注意查收${this.verifyCodeReceiveTarget}`,
            type: "is-success",
          });
        })
        .catch(() => {
          this.getCode();
        })
        .finally(() => {
          this.isSendingVerifyCode = false;
        });
    },
    handleLogin(e) {
      if (this.isLoading) {
        return;
      }
      if (this.loginType === "account") {
        this.validateUsername();
        this.validatePwd();
        this.validateCode();
        if (!this.pwdValid || !this.usernameValid || !this.codeValid) {
          this.indefinteToast = this.$buefy.toast.open({
            duration: 3000,
            message: `请检查输入的账号、密码和图形验证码`,
            type: "is-warning",
          });
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch("login", this.loginForm)
          .then((res) => {
            this.isComponentModalActive = false;
            console.log("login success");
            this.$emit("loginSuccess");
            const okEvent = new CustomEvent("csCustomLoginSuccessEvent", {
              detail: {}, // 自定义事件的详细信息
              bubbles: true, // 事件是否冒泡
              cancelable: true, // 事件是否可以被取消
            });
            document.dispatchEvent(okEvent);
          })
          .catch((err) => {
            this.loginForm.code = "";
            this.getCode();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.validatePhone();
        if (this.accountType) {
          this.validatePhoneCode();
          this.validateSmsCode();
        }
        if (!this.phoneValid || !this.smsCodeValid || !this.phoneCodeValid) {
          this.phoneForm.verifyCode = "";
          this.phoneForm.code = "";
          this.getCode();
          this.indefinteToast = this.$buefy.toast.open({
            duration: 3000,
            message: this.getPhoneLoginSubmitMessage(),
            type: "is-warning",
          });
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch(this.loginActionName, this.buildLoginData())
          .then((res) => {
            this.isComponentModalActive = false;
            console.log("phone login success");
            this.$emit("loginSuccess");
            const okEvent = new CustomEvent("csCustomLoginSuccessEvent", {
              detail: {},
              bubbles: true,
              cancelable: true,
            });
            document.dispatchEvent(okEvent);
          })
          .catch((err) => {
            this.phoneForm.verifyCode = "";
            this.phoneForm.code = "";
            this.getCode();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-zc {
  outline: none;
  color: #57aecc;
  font-size: 14px;
}
.wechat-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 6px;
  .wechat-icon-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #09bb07;
    font-size: 16px;
    text-decoration: none;
    user-select: none;
    outline: none;
    .wechat-icon {
      width: 32px;
      height: 32px;
      display: block;
    }
    &:hover {
      color: #06ad56;
    }
  }
}
.login-trigger-button {
  border-color: #57aecc;
  color: #57aecc;
  width: 75px;
  height: 35px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px !important;
  font-size: 18px;
  font-weight: 500;
}
.login-trigger-button:hover {
  background-color: #57aecc;
  color: #fff;
}
.login-footer-btn {
  display: flex;
  justify-content: space-between;
  padding: 20px 0 10px;
  box-sizing: border-box;
  .item-btn {
    flex: 1;
    &:first-child {
      margin-right: 20px;
    }
  }
}
.login-box-r {
  // 普通登录框：右栏按表单宽度收窄并居中（原先是靠 form 上的 inline width:354px 撑开，
  // 该 inline 样式在远端提交里已移除，这里改成显式宽度，避免 flex 子项宽度不可控）
  width: 354px;
  margin: 0 auto;
  text-align: left;
  padding-top: 22px;
}
.login-box {
  width: 950px;
  height: 540px;
  background-color: #fff;
  display: flex;
  align-items: center;
  z-index: 1000;
  .login-box-l {
    width: 50%;
    height: 540px;
    background: url("../assets/login/login-bg.jpg") no-repeat center center;
    background-size: cover;
  }
}
.login-box.wechat-login-box {
  width: 950px;
  height: 540px;
  overflow: hidden;

  .login-box-l {
    height: 540px;
  }

  .login-box-r {
    width: 50%;
    height: 100%;
    align-self: stretch;
    box-sizing: border-box;
    margin: 0;
    padding: 40px 20px 20px;
    display: flex;
    flex-direction: column;
  }

  .login-box-r > form {
    width: 100% !important;
  }

  .login-tabs {
    flex: none;
    width: 100%;
    margin-bottom: 30px;

    .tab-item {
      padding: 10px 20px;
      font-size: 16px;
    }
  }
}
.login-tabs {
  display: flex;
  margin-bottom: 16px;
  border-bottom: 2px solid #e0e0e0;

  .tab-item {
    flex: 1;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    transition: all 0.3s;
    position: relative;
    white-space: nowrap;
    text-align: center;

    &:hover {
      color: #57aecc;
    }

    &.active {
      color: #57aecc;
      font-weight: 500;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #57aecc;
      }
    }
  }
}
.login-btn {
  cursor: pointer;
  width: 60px;
  line-height: 26px;
  border-radius: 6px;
  border: 1px solid rgba(73, 168, 200, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(87, 174, 204, 1);
  text-align: center;
}
.input-field {
  display: flex;
  align-items: center;
  gap: 6px;
  .control {
    flex: 1;
  }
  .send-code-btn {
    color: #57aecc;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    user-select: none;

    &:hover:not(.disabled) {
      color: #4a96b3;
      text-decoration: underline;
    }

    &.disabled {
      color: #ccc;
      cursor: not-allowed;
    }
  }
}
.field :deep(.help) {
  color: hsl(348, 86%, 61%);
}
.wechat-login-panel {
  min-height: 0;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  color: #666;
  overflow: hidden;
}
.wechat-back-btn {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 4px;
  margin: -6px 0 10px;
  padding: 4px 8px;
  border: none;
  background: transparent;
  color: #57aecc;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  user-select: none;
  outline: none;
  .wechat-back-arrow {
    box-sizing: border-box;
    width: 9px;
    height: 9px;
    border-left: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg);
    flex: none;
  }
  &:hover {
    color: #4a96b3;
  }
}
.wechat-qr-frame {
  flex: none;
  width: 300px;
  height: 406px;
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-sizing: border-box;
}
.wechat-login-iframe {
  display: block;
  width: 300px;
  height: 406px;
  border: 0;
  overflow: hidden;
  background: transparent;
  margin: 0;
}
.wechat-login-message {
  width: 100%;
  margin: 5px 0 9px;
  min-height: 20px;
  font-size: 14px;
  line-height: 20px;
}
.wechat-phone-form {
  width: 100%;
  margin: 0 auto 5px;
}
.wechat-contact-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}
.wechat-phone-form .control,
.wechat-phone-form .input {
  width: 100%;
}
.wechat-phone-form .field {
  margin-bottom: 10px;
}
.wechat-phone-actions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 12px;
}
.wechat-phone-actions .button {
  min-width: 96px;
}
.wechat-code-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}
.wechat-code-row .control {
  flex: 1;
  min-width: 0;
}
.wechat-send-code {
  flex: 0 0 116px;
  white-space: nowrap;
}
.wechat-binding-box {
  width: min(554px, calc(100vw - 32px));
  height: auto;
  min-height: 414px;
  display: block;
  overflow: hidden;
  border-radius: 8px;
  margin: auto;
}
.login-box.wechat-login-box.wechat-binding-box {
  width: min(554px, calc(100vw - 32px));
  height: auto;
  min-height: 414px;
  display: block;
  margin: auto;
}
.login-box.wechat-login-box.wechat-binding-box .login-box-r {
  width: 100%;
  height: auto;
  display: block;
  padding: 46px 30px 30px;
}
.wechat-binding-box .login-box-l,
.wechat-binding-box .login-tabs {
  display: none;
}
.wechat-binding-box .login-box-r {
  width: 100%;
  height: auto;
  display: block;
  padding: 46px 30px 30px;
}
.wechat-binding-box .wechat-login-message {
  margin: 0 0 22px;
  min-height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #333;
  text-align: left;
}
.wechat-binding-box .wechat-contact-tabs {
  margin-bottom: 16px;
}
.wechat-binding-box .wechat-contact-tabs .button {
  height: 34px;
  min-height: 34px;
  padding: 0 18px;
  font-size: 14px;
}
.wechat-binding-box .wechat-phone-form .input {
  height: 48px;
  min-height: 48px;
  padding: 0 14px;
  font-size: 16px;
}
.wechat-binding-box .wechat-phone-form .field {
  margin-bottom: 12px;
}
.wechat-binding-box .wechat-phone-actions {
  margin-top: 24px;
  justify-content: space-between;
}
.wechat-binding-box .wechat-phone-actions .button {
  min-width: 0;
  height: 48px;
  min-height: 48px;
  flex: 1;
  padding: 0 18px;
  font-size: 18px;
}
.wechat-binding-box .wechat-code-row {
  gap: 16px;
}
.wechat-binding-box .wechat-send-code {
  flex-basis: 174px;
  font-size: 16px;
}
.wechat-binding-modal :deep(.modal-content) {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
